module.exports = __webpack_public_path__ + "img/745359_BFAEA8_9B8384_AC9392-256px.1836a04f.png";